













import { Component, Vue, Prop } from "vue-property-decorator";
import NoImage from "./no-image.vue";

@Component({ components: { NoImage } })
class StandartImage extends Vue {
  @Prop({ type: String, default: "" }) image!: string;
  @Prop({ type: String, default: "" }) folder!: string;
  @Prop({ type: String, default: "background" }) type!: string;
  @Prop({ type: Boolean, default: false }) local!: boolean;

  get poster(): string {
    if (this.local) return this.$getLocalImage(this.image, this.folder);
    return this.$getRemoteImage(this.image, this.folder);
  }
}
export default StandartImage;
